import { DateTime } from 'luxon';

/**
 * Format a date like so.
 */
export function formatDate(isoDate: string) {
  return DateTime.fromISO(isoDate).toFormat('DDDD');
}
